import { InjectionToken } from '@angular/core';

import { TagCommanderConfig, TagCommanderEnv } from './tag-commander.types';

export const TAG_COMMANDER_CONFIG = new InjectionToken<TagCommanderConfig>('TAG_COMMANDER_CONFIG');

export function createTagCommanderConfig(tagCommanderEnv: TagCommanderEnv): TagCommanderConfig {
  if (tagCommanderEnv === 'PROD') {
    // Configuration below should be used for environments "pilote" and "production".
    return {
      containerUrl: 'https://cdn.tagcommander.com/344/lcl_container_refonte.js',
      defaultVars: {
        site_environnement: 'PROD',
        site_parcours: 'espace_client',
        url_log: 'http://logc412',
        url_slog: 'https://logs1412',
        page_s1: '621646',
      },
    };
  }

  // Configuration below should be used for environment "recette".
  return {
    containerUrl: 'https://cdn.tagcommander.com/344/uat/lcl_container_refonte.js',
    defaultVars: {
      site_environnement: 'REC',
      site_parcours: 'espace_client',
      url_log: 'http://logc412',
      url_slog: 'https://logs1412',
      page_s1: '621647',
    },
  };
}
